// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { fromJS } from 'immutable'
import initialState from './initialState'

import {
  SET_BULK_EDIT_BAND_OPTIONS,
  SET_BULK_EDIT_HIGHLIGHTED_PATH_IDS,
  SET_BULK_EDIT_HIGHLIGHTED_SITE_IDS,
  SET_BULK_EDIT_MODAL,
  SET_BULK_EDIT_PATHS,
  SET_BULK_EDIT_VISIBLE_PATH_IDS,
  UPDATE_BULK_EDIT_STATE,
} from './types'

const bulkEdit = (state = initialState, action) => {
  switch (action.type) {
    case SET_BULK_EDIT_BAND_OPTIONS :
      return state.merge(
        fromJS({
          bulkEditBandOptions: action.bulkEditBandOptions,
        })
      )

    case SET_BULK_EDIT_HIGHLIGHTED_PATH_IDS :
      return state.merge(
        fromJS({
          highlightedPathIds: action.highlightedPathIds,
        })
      )

    case SET_BULK_EDIT_HIGHLIGHTED_SITE_IDS :
      return state.merge(
        fromJS({
          highlightedSiteIds: action.highlightedSiteIds,
        })
      )

    case SET_BULK_EDIT_MODAL :
      return state.merge(
        fromJS({
          modalConfig: action.modalConfig,
        })
      )

    case SET_BULK_EDIT_VISIBLE_PATH_IDS :
      return state.merge(
        fromJS({
          visiblePathIds: action.visiblePathIds,
        })
      )

    case UPDATE_BULK_EDIT_STATE :
      return state.merge(
        fromJS({ ...action.newState })
      )

    case SET_BULK_EDIT_PATHS :
      return state.merge(
        fromJS({
          bulkEditPaths: action.bulkEditPaths,
        })
      )

    default :
      return state
  }
}

export default bulkEdit
